import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { DreamsProvider, useDreams } from "./contexts/DreamsContext";
import DreamsLayout from "./components/DreamsLayout";
import DreamsLanding from "./pages/DreamsLanding";
import DreamsSubscribe from "./pages/DreamsSubscribe";
import DreamsDashboard from "./pages/DreamsDashboard";
import DreamsVision from "./pages/DreamsVision";
import DreamsSonhos from "./pages/DreamsSonhos";
import DreamsSonhoDetail from "./pages/DreamsSonhoDetail";
import DreamsLeaderboard from "./pages/DreamsLeaderboard";
import DreamsBoard from "./pages/DreamsBoard";
import DreamsTimeline from "./pages/DreamsTimeline";
import DreamsSupport from "./pages/DreamsSupport";
import DreamsSharePublic from "./pages/DreamsSharePublic";
import DreamsLandingPublic from "./pages/DreamsLandingPublic";

function GatedDashboard() {
  const { isSubscribed, loading } = useDreams();
  if (loading) return null;
  return isSubscribed ? <DreamsDashboard /> : <DreamsLanding />;
}

function RequireSubscription({ children }) {
  const { isSubscribed, loading } = useDreams();
  if (loading) return null;
  if (!isSubscribed) return <Navigate to="/dreams/subscribe" replace />;
  return children;
}

function AuthCheck({ children }) {
  const { error } = useDreams();
  useEffect(() => {
    if (error === "AUTH") {
      window.location.href = "/login?next=/dreams";
    }
  }, [error]);
  if (error === "AUTH") return null;
  return children;
}

export default function DreamsApp() {
  return (
    <Routes>
      {/* Páginas públicas — sem provider/auth check */}
      <Route path="share/:token" element={<DreamsSharePublic />} />
      <Route path="landing"      element={<DreamsLandingPublic />} />
      {/* Demais rotas: requerem provider e auth */}
      <Route path="*" element={
        <DreamsProvider>
          <AuthCheck>
            <Routes>
              <Route element={<DreamsLayout />}>
                <Route index element={<GatedDashboard />} />
                <Route path="subscribe" element={<DreamsSubscribe />} />
                <Route path="vision"    element={<RequireSubscription><DreamsVision /></RequireSubscription>} />
                <Route path="sonhos"    element={<RequireSubscription><DreamsSonhos /></RequireSubscription>} />
                <Route path="sonhos/:sonhoId" element={<RequireSubscription><DreamsSonhoDetail /></RequireSubscription>} />
                <Route path="board"     element={<RequireSubscription><DreamsBoard /></RequireSubscription>} />
                <Route path="timeline"  element={<RequireSubscription><DreamsTimeline /></RequireSubscription>} />
                <Route path="top"       element={<RequireSubscription><DreamsLeaderboard /></RequireSubscription>} />
                <Route path="suporte"   element={<RequireSubscription><DreamsSupport /></RequireSubscription>} />
              </Route>
            </Routes>
          </AuthCheck>
        </DreamsProvider>
      } />
    </Routes>
  );
}
